import React from 'react';
import { Modal } from '@mui/material';
import { ReactComponent as XIcon } from 'images/x.svg';
import {
  PKDModalHeader,
  PKDModalWrapper,
  PKDModalTitle,
  PKDModalContent,
  PKDModalClose,
} from './styles';


export const PKDModal = ({
  children,
  title,
  isOpen,
  onClose,
  width = '726px',
}) => {
  return (
    <Modal
      open={isOpen} onClose={onClose}>
      <PKDModalWrapper
        width={width}>
        <PKDModalHeader>
          <PKDModalTitle>{title}</PKDModalTitle>
          <PKDModalClose
            onClick={onClose} data-testid='pkd-modal-close'>
            <XIcon />
          </PKDModalClose>
        </PKDModalHeader>
        <PKDModalContent>{children}</PKDModalContent>
      </PKDModalWrapper>
    </Modal>
  );
};
